import React from "react";
import styles from "./CustomOrderForm.module.scss";
import { Button } from "../../../../primary";

export const CustomOrderForm = ({ onDownload, padType }) => {
  return (
    <div className={styles.customOrderInfo}>
      <div className={styles.customOrderContent}>
        <p>
          For a custom {padType} pad, please download and fill out the custom drawing form and email to <span>ProductSupportR&O@medline.com</span>
        </p>

        <Button type="button" className={styles.downloadBtn} onClick={onDownload}>
          Download Custom Order Form
        </Button>
      </div>
    </div>
  );
};
